import React, { useState } from "react";
import PropTypes from "prop-types";
import "./RptDatPrtRoute.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
	withBase,
	ConditionBox,
	ControlBox,
	DatePickerField,
	CodeSelect,
	Button,
	PopupWrapper,
	CustomLoading,
} from "components";
import moment from "moment";

const API = {
	LIST: {
		url: "api/v1/calc/deliveryTxn/listtotfaresum",
		method: "post",
	},
	DOWN: {
		url: "api/v1/calc/deliveryTxn/downtotfaresum",
		method: "post",
	},
};

const TOT_FARE_DATA = {
	"no": 0                           //순번
	, "plcfbName": "-"                //영업소명
	, "totFare": 0                    //합계금액(연계+직송)
	, "totPreFareFreight": 0          //현불(연계+직송)
	, "totDeferFareFreight": 0        //착불(연계+직송)
	, "totPreFareDelivery": 0         //현택(연계+직송)
	, "totDeferFareDelivery": 0      //착택(연계+직송)
	, "totFareLink" : 0               //합계금액(연계)
	, "totPreFareLinkFreight": 0      //합계금액(연계현불)
	, "totDeferFareLinkFreight": 0    //합계금액(연계착불)
	, "totPreFareLinkDelivery": 0     //합계금액(연계현택)
	, "totDeferFareLinkDelivery": 0   //합계금액(연계찰택)
	, "totFareDirect" : 0             //합계금액(직송)
	, "totPreFareDirectFreight": 0    //합계금액(직송현불)
	, "totDeferFareDirectFreight": 0  //합계금액(직송착불)
	, "totPreFareDirectDelivery": 0   //합계금액(직송현택)
	, "totDeferFareDirectDelivery": 0 //합계금액(직송착택)
	, "totCount": 0                   //합계건수
	, "divType": "-"                  //발송/도착 구분
	, "nosunCarCount": 0              //노선차량수
	, "linkCarCount": 0               //연계차량수
	, "increasePer" : 0               //할증률
};

const PRN_TOT_FARE_FIELDS = [
	{ key: "no", name: "No", type: "no", width: "6%"},
	{ key: "plcfbName", name: "영업소명", type: "text", width: "29%"},
	{ key: "totFare", name: "발송합계<br>도착합계", type: "number", width: "*"},
	{ key: "totPreFareFreight", name: "현불", type: "number", width: "*"},
	{ key: "totDeferFareFreight", name: "착불", type: "number", width: "*"},
	{ key: "totPreFareDelivery", name: "현택",  type: "number", width: "*"},
	{ key: "totDeferFareDelivery", name: "착택", type: "number", width: "*"}
];

const RptDatPrtRoute = (props) => {
	const [layerType, setLayerType] = useState("");
	const [message, setMessage] = useState("");
	const pagePerRow = 15;
	const startBodyDataListIdx = 5;
	let rowNo = 0;

	const handleClickPrintA4 = async (param) => {
		console.log("##### handleClickPrintA4");

		const { HttpRequest, searching } = props;
		setLayerType("loading");
		setMessage("출력중 입니다.");

		const { url, method } = API.LIST;
		const response = await HttpRequest.request(url, method, param);

		if (HttpRequest.hasError(response, true)) {
			setLayerType("");
			return;
		}

		const totFareList = response.totFareSumSheetList;
		if (!Array.isArray(totFareList) || totFareList.length === 0) {
			setMessage("출력할 데이터가 없습니다.");
			setLayerType("message");
			return;
		}

		if (totFareList) {
			const printerObj1 = document.getElementById("printerObj1");

			/* 기존 DOT 프린터 출력 제거(2026-08-20 양재원)
			printerObj1.Init();

			for (let i = 0; i < response.totFareSumSheetList.length; i++) {
			  printerObj1.AddData(response.totFareSumSheetList[i].rowData);
			}

			setLayerType("");
			printerObj1.Print();
			*/

			/* 신규 윈도우 프린터 출력 추가(2026-08-21 양재원) */
			// 기존 출력 DOM 초기화
			printerObj1.replaceChildren();

			// 커버용 내용
			let coverContent = "";
			for (let idx = 0; idx < startBodyDataListIdx; idx++) {
				const rowData = totFareList[idx]?.rowData;

				// rowData가 존재하고 "DH"로 시작하는지 검사
				if (rowData && rowData.startsWith("DH")) {
					// 맨 앞의 "DH"만 제거 후 <br> 추가
					// 기존 내용에 rowData와 줄바꿈 태그(<br>)를 이어 붙임
					const cleanedData = rowData.slice(2); // 또는 rowData.replace(/^DH/, "");
					coverContent += cleanedData + "<br>";
				}
			}

			// 출력용 Title
			let pageTitle =  "";
			for (let idx = 0; idx < startBodyDataListIdx; idx++) {
				const rowData = totFareList[idx]?.rowData;

				// rowData가 존재하고 "PH"로 시작하는지 검사
				if (rowData && rowData.startsWith("PH")) {
					// 맨 앞의 "DH"만 제거 후 <br> 추가
					// 기존 내용에 rowData와 줄바꿈 태그(<br>)를 이어 붙임
					const cleanedData = rowData.slice(2); // 또는 rowData.replace(/^DH/, "");
					pageTitle += cleanedData;
				}
			}

			// 출력용 Body
			const dataList = [];
			rowNo = 0;
			for (let idx = startBodyDataListIdx; idx < totFareList.length; idx++) {
				dataList.push(convertBody(totFareList[idx]));
			}

			const fragment = document.createDocumentFragment();

			// 커버 페이지
			fragment.appendChild(createCoverPage(coverContent));

			// no 기준으로 한 페이지당 15개씩 분할
			const pageDataList = splitDataByPage(dataList, pagePerRow);
			const totalPageCount = pageDataList.length;

			// 데이터 페이지 생성
			let cumulativeDataList = [];
			pageDataList.forEach((pageData, pageIndex) => {
				cumulativeDataList = cumulativeDataList.concat(pageData);
				fragment.appendChild(
					createPrintPage(
						pageTitle,
						pageData,
						pageIndex + 1,
						totalPageCount,
						cumulativeDataList
					)
				);
			});

			printerObj1.appendChild(fragment);

			// React 및 브라우저 렌더링 완료 후 출력
			await waitForRender();

			printElement(printerObj1, true);
		}
		setLayerType("");
	};

	const handleClickPrint = async (param) => {
		const { HttpRequest, searching } = props;
		setLayerType("loading");
		setMessage("출력중 입니다.");

		const { url, method } = API.LIST;
		const response = await HttpRequest.request(url, method, param);

		if (HttpRequest.hasError(response, true)) {
			setLayerType("");
			return;
		}

		const totFareList = response.totFareSumSheetList;
		if (!Array.isArray(totFareList) || totFareList.length === 0) {
			setMessage("출력할 데이터가 없습니다.");
			setLayerType("message");
			return;
		}

		if (totFareList) {
			const printerObj1 = document.getElementById("printerObj1");

			//기존 DOT 프린터 출력
			printerObj1.Init();

			for (let i = 0; i < response.totFareSumSheetList.length; i++) {
			  printerObj1.AddData(response.totFareSumSheetList[i].rowData);
			}

			setLayerType("");
			printerObj1.Print();
		}
		setLayerType("");
	};


	//집계용 커버 페이지 DOM 생성
	const createCoverPage = (coverContent) => {
		//커버 페이지 생성
		const coverPage = document.createElement("section");
		coverPage.className = "print-page cover-page";

		//커버 페이지 내용의 중심을 상단 1/3 지점에 고정
		coverPage.style.position = "relative";
		coverPage.style.height = "100vh";			//페이지 전체 높이 확보
		coverPage.style.textAlign = "center";		//텍스트 가운데 정렬

		//커버 페이지 내용 생성 및 삽입 (<br> 태그가 포함되어 있으므로 innerHTML 사용)
		const coverContentDiv = document.createElement("div");
		coverContentDiv.className = "cover-content";
		coverContentDiv.style.position = "absolute";
		coverContentDiv.style.top = "33.333%";
		coverContentDiv.style.left = "50%";
		coverContentDiv.style.width = "100%";
		coverContentDiv.style.transform = "translate(-50%, -50%)";

		//폰트 크기 및 줄간격 스타일 추가
		let idx = 0;
		let contents = coverContent.split("<br>");
		contents.forEach((content, idx) => {
			// 공백 라인인 경우 건너뛰거나 간격용 요소 생성
			if (!content.trim()) return;

			// 각 줄을 담을 개별 엘리먼트 생성
			const lineItem = document.createElement("div");
			lineItem.textContent = content; // 텍스트만 안전하게 주입

			// 기본 스타일
			lineItem.style.fontSize = "6vw";   // 기본 크기
			lineItem.style.fontStyle = "oblique";
			lineItem.style.lineHeight = "2.4"; // 기본 줄간격

			// 특정 줄(예: TITLE) 개별 스타일 적용
			if (idx === 1) {
				lineItem.style.fontSize = "8vw";   // TITLE 강조 크기
				lineItem.style.fontStyle = "normal";
				lineItem.style.fontWeight = "bold"; // 필요 시 굵게 처리
				lineItem.style.lineHeight = "2.4"; // 강조 줄간격
			}

			// 각 줄을 메인 컨테이너에 추가
			coverContentDiv.appendChild(lineItem);
		});
		coverPage.appendChild(coverContentDiv);

		return coverPage;
	}


	//집계용 데이터 출력 페이지 DOM 생성
	const createPrintPage = (
		pageTitle,
		dataList,
		currentPage,
		totalPage,
		cumulativeDataList
	) => {
		const pageFields = JSON.parse(
			JSON.stringify(PRN_TOT_FARE_FIELDS)
		);

		// 운임 페이지 생성
		const page = document.createElement("section");
		page.className = "print-page data-page";

		// 한 페이지 안에서 footer를 하단으로 배치
		page.style.display = "flex";
		page.style.flexDirection = "column";

		// 모든 페이지 상단 TITLE
		const title = document.createElement("h1");
		title.className = "print-title";
		title.style.position = "relative";
		title.style.width = "100%";

		const pageTitleText = String(pageTitle ?? "");
		const timeMatch = pageTitleText.match(
			/(?:^|\s)(\d{1,2})\s*[:：]\s*(\d{2})\s*[:：]\s*(\d{2})(?!\d)/
		);
		const titleText = document.createElement("span");
		titleText.textContent = timeMatch
			? pageTitleText.replace(timeMatch[0], "").trim()
			: pageTitleText;
		titleText.style.display = "block";
		titleText.style.paddingRight = "120px";
		titleText.style.textAlign = "left";
		title.appendChild(titleText);

		if (timeMatch) {
			const timeText = document.createElement("span");
			timeText.textContent = `${timeMatch[1]}:${timeMatch[2]}:${timeMatch[3]}`;
			timeText.style.position = "absolute";
			timeText.style.top = "0";
			timeText.style.right = "0";
			timeText.style.textAlign = "right";
			title.appendChild(timeText);
		}
		page.appendChild(title);

		// 테이블 생성
		const table = document.createElement("table");
		table.className = "print-table";
		table.style.tableLayout = "fixed";
		table.style.width = "100%";
		table.style.borderCollapse = "collapse";

		// COLGROUP
		const colgroup = document.createElement("colgroup");

		pageFields.forEach((field) => {
			const col = document.createElement("col");

			if (field.width && field.width !== "*") {
				col.style.width = field.width;
			}

			colgroup.appendChild(col);
		});

		table.appendChild(colgroup);

		// THEAD
		const thead = document.createElement("thead");
		const headerTr = document.createElement("tr");

		pageFields.forEach(({ name }) => {
			const th = document.createElement("th");
			th.innerHTML = name ?? "";
			th.style.textAlign = "center";
			th.style.verticalAlign = "middle";
			th.style.fontWeight = "bold";
			th.style.backgroundColor = "#f2f2f2";
			th.style.webkitPrintColorAdjust = "exact";
			th.style.printColorAdjust = "exact";

			headerTr.appendChild(th);
		});

		thead.appendChild(headerTr);
		table.appendChild(thead);

		// TBODY
		const tbody = document.createElement("tbody");
		let rowIdx = 0;

		dataList.forEach((data) => {
			const tr = document.createElement("tr");

			// 위·아래 테두리 설정
			if (data.no !== "") {
				tr.style.borderTop = "1px solid #000";
			} else {
				tr.style.borderBottom = "1px solid #000";
			}

			// 짝수 묶음 배경색
			if (rowIdx % 2 !== 0) {
				tr.style.backgroundColor = "#F9F9FA";
				tr.style.webkitPrintColorAdjust = "exact";
				tr.style.printColorAdjust = "exact";
			}

			pageFields.forEach(({ key, type }) => {
				const td = document.createElement("td");

				switch (type) {
					case "no":
						td.textContent = data[key] === ""
							? ""
							: formatNumber(data[key]);
						td.style.textAlign = "right";
						break;

					case "number":
						td.textContent = formatNumber(data[key]);
						td.style.textAlign = "right";
						break;

					default:
						td.textContent = data[key] ?? "";
						td.style.textAlign = "left";
						break;
				}

				tr.appendChild(td);
			});

			tbody.appendChild(tr);

			// 하나의 번호 묶음이 끝났을 때 색상 순번 증가
			if (data.no === "") {
				rowIdx++;
			}
		});

		// 현재 페이지까지의 누적 발송/도착 합계 행 추가
		const tfoot = document.createElement("tfoot");
		const numberFields = pageFields.filter(({ type }) => type === "number");
		const nyTotals = cumulativeDataList.reduce((totals, { no, plcfbName }) => {
			if (no !== "") {
				return totals;
			}

			const plcfbNameText = String(plcfbName ?? "");
			const closingParenthesisIndex = plcfbNameText.indexOf(")");
			if (!plcfbNameText.startsWith("(") || closingParenthesisIndex < 0) {
				return totals;
			}
			const summaryText = plcfbNameText.slice(closingParenthesisIndex + 1);

			["N", "Y"].forEach((type) => {
				const valueMatch = summaryText.match(
					new RegExp(`${type}\\s*[:=]?\\s*([\\d,]+)`, "i")
				);

				if (valueMatch) {
					totals[type] += Number(valueMatch[1].replace(/,/g, ""));
				}
			});

			return totals;
		}, { N: 0, Y: 0 });
		const summaryRows = [
			{
				noLabel: "발송",
				label: `  노선(N)${nyTotals.N} / 연노(Y)${nyTotals.Y}`,		//누적 발송합계
				rows: cumulativeDataList.filter(({ no }) => no !== ""),
			},
			{
				noLabel: "도착",
				label: "",		//누적 도착합계
				rows: cumulativeDataList.filter(({ no }) => no === ""),
			},
		];

		summaryRows.forEach(({ noLabel, label, rows }, summaryIndex) => {
			const summaryData = {
				no: noLabel,
				plcfbName: label,
			};

			numberFields.forEach(({ key }) => {
				summaryData[key] = rows.reduce((sum, row) => {
					const value = Number(
						String(row[key] ?? 0).replace(/,/g, "").trim()
					);

					return sum + (Number.isFinite(value) ? value : 0);
				}, 0);
			});

			const tr = document.createElement("tr");
			tr.style.fontWeight = "bold";
			tr.style.backgroundColor = "#f2f2f2";
			tr.style.webkitPrintColorAdjust = "exact";
			tr.style.printColorAdjust = "exact";
			if (summaryIndex === 0) {
				tr.style.borderTop = "1px solid #000";
			}
			if (summaryIndex === summaryRows.length - 1) {
				tr.style.borderBottom = "1px solid #000";
			}

			pageFields.forEach(({ key, type }) => {
				const td = document.createElement("td");
				td.textContent = type === "number"
					? formatNumber(summaryData[key])
					: summaryData[key] ?? "";
				td.style.textAlign = type === "text" ? "left" : "right";
				tr.appendChild(td);
			});

			tfoot.appendChild(tr);
		});
		table.appendChild(tbody);
		table.appendChild(tfoot);
		page.appendChild(table);

		// 마지막 페이지에 약 10줄의 여백 후 전체 합계 테이블 추가
		if (currentPage === totalPage) {
			const totalTable = table.cloneNode(true);
			totalTable.className = "print-table total-summary-table";
			totalTable.style.marginTop = "10em";
			totalTable.querySelector("tbody").replaceChildren();
			totalTable.querySelector("thead").remove();
			totalTable.querySelector("tfoot").remove();

			//page.appendChild(totalTable);
		}

		// 페이지 하단 번호
		const footer = document.createElement("div");
		footer.className = "print-footer";
		footer.textContent = `${currentPage} / ${totalPage}`;

		page.appendChild(footer);

		return page;
	};


	//no가 있는 데이터를 기준으로 페이지당 15개씩 분할
	const splitDataByPage = (dataList, rowCount = 15) => {
		const pages = [];

		let currentPage = [];
		let currentNoCount = 0;

		dataList.forEach((data) => {
			const hasNo =
				data.no !== "" &&
				data.no !== null &&
				data.no !== undefined;

			/*
			 * 현재 페이지에 no가 15개 들어간 상태에서
			 * 다음 번호 행이 시작되면 새 페이지 생성
			 *
			 * no가 없는 행은 앞 번호의 부가 행으로 보고
			 * 기존 페이지에 함께 포함
			 */
			if (hasNo && currentNoCount >= rowCount) {
				pages.push(currentPage);

				currentPage = [];
				currentNoCount = 0;
			}

			currentPage.push(data);

			if (hasNo) {
				currentNoCount++;
			}
		});

		// 마지막 페이지 추가
		if (currentPage.length > 0) {
			pages.push(currentPage);
		}

		return pages;
	};


	//ROW 문자열을 data 객체로 변환
	const convertBody = (row) => {
		const item = row.rowData.split("|");
		let data = JSON.parse(JSON.stringify(TOT_FARE_DATA));
		data.plcfbName = item[0].replace("BD", "") ?? "-";
		data.no = !(data.plcfbName?.startsWith('(') && data.plcfbName?.includes(')')) ? ++rowNo : "";
		data.totFare = item[1] ?? 0;
		data.totFareLink = item[2] ?? 0;
		data.totPreFareLinkFreight = item[3] ?? 0;
		data.totDeferFareLinkFreight = item[4] ?? 0;
		data.totPreFareLinkDelivery = item[5] ?? 0;
		data.totDeferFareLinkDelivery = item[6] ?? 0;
		data.totFareDirect = item[7] ?? 0;
		data.totPreFareDirectFreight = item[8] ?? 0;
		data.totDeferFareDirectFreight = item[9] ?? 0;
		data.totPreFareDirectDelivery = item[10] ?? 0;
		data.totDeferFareDirectDelivery = item[11] ?? 0;
		data.totCount = item[12] ?? 0;
		data.divType = item[13] ?? "-";
		data.nosunCarCount = item[14] ?? 0;
		data.linkCarCount = item[15] ?? 0;
		data.increasePer = item[16] ?? 0;

		data.totPreFareFreight = parseInt(data.totPreFareLinkFreight.trim().replaceAll(",", ""), 10) + parseInt(data.totPreFareDirectFreight.trim().replaceAll(",", ""), 10);
		data.totDeferFareFreight = parseInt(data.totDeferFareLinkFreight.trim().replaceAll(",", ""), 10) + parseInt(data.totDeferFareDirectFreight.trim().replaceAll(",", ""), 10);
		data.totPreFareDelivery = parseInt(data.totPreFareLinkDelivery.trim().replaceAll(",", ""), 10) + parseInt(data.totPreFareDirectDelivery.trim().replaceAll(",", ""), 10);
		data.totDeferFareDelivery = parseInt(data.totDeferFareLinkDelivery.trim().replaceAll(",", ""), 10) + parseInt(data.totDeferFareDirectDelivery.trim().replaceAll(",", ""), 10);

		//console.log("##### convertBody.row", data);
		return data;
	}


	//숫자인지 확인 및 숫자인 경우 천단위 콤마 추가
	const formatNumber = (value) => {
		if (
			value === null ||
			value === undefined ||
			value === ""
		) {
			return "0";
		}

		// 이미 쉼표가 포함된 문자열도 숫자로 변환
		const numberValue = Number(
			String(value).replace(/,/g, "").trim()
		);

		return Number.isFinite(numberValue)
			? numberValue.toLocaleString("ko-KR")
			: "0";
	};


	//DOM 렌더링을 기다림
	const waitForRender = () =>
		new Promise((resolve) => {
			requestAnimationFrame(() => {
				requestAnimationFrame(resolve);
			});
		});


	//특정 DOM 출력
	const printElement = (element, useA4PageStyle = false) => {
		const printIframe = document.createElement("iframe");

		printIframe.style.position = "fixed";
		printIframe.style.right = "0";
		printIframe.style.bottom = "0";
		printIframe.style.width = "0";
		printIframe.style.height = "0";
		printIframe.style.border = "0";

		document.body.appendChild(printIframe);

		const printDocument =
			printIframe.contentDocument ||
			printIframe.contentWindow.document;

		printDocument.open();
		printDocument.write(`
		<!DOCTYPE html>
		<html lang="ko">
		<head>
		<meta charset="UTF-8" />
		<title>운임 합계표 출력</title>
		
		<style>
			${useA4PageStyle ? `@page {
				size: A4 portrait;
				margin: 10mm;
			
				/* 인쇄 시 배경색 강제 출력 옵션 */
				-webkit-print-color-adjust: exact;
				print-color-adjust: exact;
			}` : ""}
			
			* {
				box-sizing: border-box;
			}
			
			body {
				margin: 0;
				color: #000;
				font-family: Arial, "Malgun Gothic", sans-serif;
			}

			.print-page {
				width: 100%;
				min-height: 277mm;
				box-sizing: border-box;
			
				break-after: page;
				page-break-after: always;
			}
			
			.print-page:last-child {
				break-after: auto;
				page-break-after: auto;
			}
			
			.data-page {
				display: flex;
				flex-direction: column;
			}
			
			.print-title {
				flex: 0 0 auto;
				margin: 0 0 15px;
				text-align: left;
				font-size: 22px;
			}

			.page-break-before {
				break-before: page;
				page-break-before: always;
			}

			.print-table {
				flex: 0 0 auto;
				width: 100%;
				border-collapse: collapse;
				table-layout: fixed;
			}
			
			.print-table tr {
				break-inside: avoid;
				page-break-inside: avoid;
			}
			
			.print-table tbody tr:nth-child(even) td {
				padding-bottom: 10px;
			}
          
			.print-table th {
				background-color: #f2f2f2;
				font-size: 14px;
				word-break: break-all;
				border-top: 1px solid #000;
				border-bottom: 1px solid #000;
			}
			
			.print-table th,
			.print-table td {
				padding: 5px 5px 5px 5px;
				border-right: 1px solid #000;
			}
			
			.print-table td {
				font-size: 12px;
				word-break: break-all;
			}
			
			/* 컬럼의 오른쪽 세로선 제거 */
			.print-table th:last-child,
			.print-table td:last-child {
				border-right: none;
			}
			
			.print-footer {
				margin-top: auto;
				padding-top: 10px;
				text-align: center;
				font-size: 11px;
				color: #000;
			}
		</style>
		</head>
		
		<body>
			${element.innerHTML}
		</body>
		</html>
  `);
		printDocument.close();

		printIframe.onload = () => {
			const printWindow = printIframe.contentWindow;

			printWindow.focus();
			printWindow.print();

			// 인쇄 대화상자가 닫힌 후 iframe 제거
			printWindow.onafterprint = () => {
				printIframe.remove();
			};
		};
	};


	const handleClickDown = async (param) => {
		const { url } = API.DOWN;

		await props.downExcel.request(url, param);
	};


	return (
		<div className="RptDatPrtRoute">
			<Formik
				initialValues={{
					btnType: "",
					sumDate: moment().add(-1, "days"),
					phydsCorpDiv: "",
				}}
				onSubmit={(values, { setSubmitting }) => {
					setSubmitting(true);
					if (values.btnType === "print") {
						handleClickPrint({
							sumDate: moment(values.sumDate).format("YYYYMMDD"),
							phydsCorpDiv: values.phydsCorpDiv,
						});
					} else if (values.btnType === "printA4") {
						handleClickPrintA4({
							sumDate: moment(values.sumDate).format("YYYYMMDD"),
							phydsCorpDiv: values.phydsCorpDiv,
						});
					} else if (values.btnType === "excel") {
						handleClickDown({
							sumDate: moment(values.sumDate).format("YYYYMMDD"),
							phydsCorpDiv: values.phydsCorpDiv,
						});
					}
					setSubmitting(false);
				}}
				validationSchema={Yup.object().shape({
					sumDate: Yup.date().required().nullable(),
					phydsCorpDiv: Yup.string().required(),
				})}
			>
				{(props) => {
					const { values, touched, errors, handleChange, handleSubmit } = props;
					return (
						<>
							<Form onSubmit={handleSubmit}>
								<ConditionBox>
									<div className="HasTable">
										<table>
											<tbody>
											<tr>
												<td>
													<dl>
														<dt>
															발송일<i></i>
															<span>
                                  {errors.sumDate &&
									  touched.sumDate &&
									  errors.sumDate}
                                </span>
														</dt>
														<dd>
															<div className="HasDate">
																<DatePickerField
																	name="sumDate"
																	date={values.sumDate}
																/>
															</div>
														</dd>
													</dl>
													<dl>
														<dt>
															법인<i></i>
															<span>
                                  {errors.phydsCorpDiv &&
									  touched.phydsCorpDiv &&
									  errors.phydsCorpDiv}
                                </span>
														</dt>
														<dd>
															<CodeSelect
																codeId="PHYDS_CORP_DIV"
																name="phydsCorpDiv"
																onChange={handleChange}
																onBlur={handleChange}
																placeholder={"법인 선택"}
																value={values.phydsCorpDiv}
															/>
														</dd>
													</dl>
												</td>
												<td></td>
											</tr>
											</tbody>
										</table>
									</div>
								</ConditionBox>
								<ControlBox>
                  <span className="info_text">
                    정산 프로그램을 통한 각각의 집계현황이며, 확인 및 출력이
                    가능합니다.
                  </span>
								</ControlBox>

								<div className="tb_area">
									<article className="grid_data">
										<div className="thead">
											<table>
												<colgroup>
													{["100%"].map((i, key) => {
														return <col width={i} key={key} />;
													})}
												</colgroup>
												<tbody>
												<tr>
													{["총운임 집계표"].map((i, key) => {
														return <th key={key}>{i}</th>;
													})}
												</tr>
												</tbody>
											</table>
										</div>
										<div className="tbody NoreSize">
											<table>
												<colgroup>
													{["50%", "*"].map((i, key) => {
														return <col width={i} key={key} />;
													})}
												</colgroup>
												<tbody>
												<tr>
													<td className="text">총운임 집계표</td>
													<td>
														<Button
															type="button"
															className="print"
															onClick={() => {
																values.btnType = "printA4";
																handleSubmit();
															}}
														>
															(A4) 출력하기
														</Button>
														<Button
															className="print"
															onClick={() => {
																values.btnType = "print";
																handleSubmit();
															}}
														>
															출력하기
														</Button>
														<Button
															className="excel"
															onClick={() => {
																values.btnType = "excel";
																handleSubmit();
															}}
														>
															엑셀 다운로드
														</Button>
													</td>
												</tr>
												</tbody>
											</table>
										</div>
									</article>
								</div>
							</Form>
						</>
					);
				}}
			</Formik>
			<PopupWrapper
				layerType={layerType}
				title={""}
				loading={<CustomLoading layerType={layerType}>{message}</CustomLoading>}
			/>
		</div>
	);
};

RptDatPrtRoute.propTypes = {};

export default withBase(RptDatPrtRoute);
